import React, { FC } from "react";
import { Select } from "../../atoms/Select";
import { InputField, InputTitle } from "./elements";

type Props = {
  label: string;
  selectOnChange?: (e: any) => void;
  selectDefaultValue: string | undefined;
  optionItems?: JSX.Element;
  selectWidth?: string;
  disabled?: boolean;
  placeholder?: string;
  getPopupContainer?: any;
  noMarginTop?: boolean;
  error?: boolean;
  value?: any;
};

const SelectWithLabel: FC<Props> = (props) => {
  const {
    label,
    selectOnChange,
    selectDefaultValue,
    optionItems,
    selectWidth,
    disabled,
    placeholder,
    getPopupContainer,
    noMarginTop,
    error,
    value,
  } = props;

  return (
    <InputField noMarginTop={noMarginTop || false}>
      <InputTitle>{label}</InputTitle>
      <Select
        placeholder={placeholder}
        handleChange={selectOnChange}
        defaultValue={selectDefaultValue}
        optionItems={optionItems}
        width={selectWidth}
        disabled={disabled}
        getPopupContainer={getPopupContainer}
        error={error}
        value={value}
      />
    </InputField>
  );
};

export default SelectWithLabel;
